The HTML snippet to prompt the candidate for consent.

Unsupported tags will be silently stripped when creating a questionnaire.

This is optional and will default to 'Do you agree to the privacy policy?'.
